import React, { Component } from 'react';
import _ from "lodash";
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../helpers/AsyncFunc';

let communityFeatureList = null;
let communityType = _.isNil(localStorage.getItem('communityType')) || localStorage.getItem('communityType') === undefined ? 'CONDO' : localStorage.getItem('communityType')

class AppRouter extends Component {

  constructor(props) {
    super(props);
    communityFeatureList = JSON.parse(localStorage.getItem('communityFeatureList'));
  }
  

  render() {
    const { url, style } = this.props;

    const routes = [
      {
        path: '',
        component: asyncComponent(() => import('../Page/Dashboard/index')),
        isEnable: true,
        isVisible: true,
      },
      {
        path: 'home',
        component: asyncComponent(() => import('../Page/Home/home')),
        isEnable: true,
        isVisible: true,
      },
      {
        path: 'issuetracking',
        component: asyncComponent(() => import('../Page/IssueTracking')),
        //isEnable: true,
        isEnable: communityType !== null && communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ISSUE_TRACKING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType !== null && communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ISSUE_TRACKING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'issuetracking/group',
        component: asyncComponent(() => import('../Page/IssueTracking/IssueTrackingTaskList')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ISSUE_TRACKING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ISSUE_TRACKING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'issuetracking/group/task',
        component: asyncComponent(() => import('../Page/IssueTracking/IssueTrackingTaskDetail')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ISSUE_TRACKING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ISSUE_TRACKING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'parcel',
        component: asyncComponent(() => import('../Page/Parcel/')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'parcelimport',
        component: asyncComponent(() => import('../Page/Parcel/CreateNewParcel/index')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'parcelreport',
        component: asyncComponent(() => import('../Page/Parcel/Report/index')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'parcelprintout',
        component: asyncComponent(() => import('../Page/Parcel/ParcelPrintout/index')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'parcelsearch',
        component: asyncComponent(() => import('../Page/Parcel/ParcelSearch/index')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'newparcel',
        component: asyncComponent(() => import('../Page/Parcel/CreateNewParcel/index')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'parcelexport',
        component: asyncComponent(() => import('../Page/Parcel/ExportParcel/index')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'parceloverdue',
        component: asyncComponent(() => import('../Page/Parcel/ParcelOverdue/index')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'parcelSettings',
        component: asyncComponent(() => import('../Page/Parcel/ParcelSettings/index')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'profile',
        component: asyncComponent(() => import('../Page/UserProfile')),
        isEnable: true,
        isVisible: true,
      },
      {
        path: 'profile/edit',
        component: asyncComponent(() => import('../Page/UserProfile/userForm')),
        isEnable: true,
        isVisible: true,
      },
      {
        path: 'communityInfo',
        component: asyncComponent(() => import('../Page/Community/CommunityInfo')),
        isEnable: true,
        isVisible: true,
      },
      {
        path: 'announcement',
        component: asyncComponent(() => import('../Page/Announcement')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ANNOUNCEMENT').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ANNOUNCEMENT').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'announcement/newpost',
        component: asyncComponent(() => import('../Page/Announcement/CreateAnnouncement')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ANNOUNCEMENT').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ANNOUNCEMENT').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'directory',
        component: asyncComponent(() => import('../Page/Directory')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
      },
      {
        path: 'directory/invitecodegen',
        component: asyncComponent(() => import('../Page/Directory/InvitationGen')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
      },
      {
        path: 'directory/invitecodegenpmc',
        component: asyncComponent(() => import('../Page/Directory/GeneratePMCInvitationCode')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
      },
      {
        path: 'directory/residentlist',
        component: asyncComponent(() => import('../Page/Directory/Resident')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
      },
      {
        path: 'directory/communitymembers',
        component: asyncComponent(() => import('../Page/Directory/CommunityMembers')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
      },
      {
        path: 'directory/committeemembers',
        component: asyncComponent(() => import('../Page/Directory/CommitteeMembers')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
      },
      {
        path: 'directory/pmcmembers',
        component: asyncComponent(() => import('../Page/Directory/PMCMembers')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
      },
      {
        path: 'directory/room',
        component: asyncComponent(() => import('../Page/Directory/RoomDirectory')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
      },
      {
        path: 'directory/room/:unitNo',
        component: asyncComponent(() => import('../Page/Directory/RoomDirectory/roomDetail')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
      },
      {
        path: 'billing',
        component: asyncComponent(() => import('../Page/Billing/')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'billing/list',
        component: asyncComponent(() => import('../Page/Billing/BillingList')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'billing/list/detail/:billingID',
        component: asyncComponent(() => import('../Page/Billing/BillingList/BillingDetail')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'billing/list/newbill',
        component: asyncComponent(() => import('../Page/Billing/CreateBill')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'billing/evidence',
        component: asyncComponent(() => import('../Page/Billing/BillingEvidence')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'billing/searchbillingevidence',
        component: asyncComponent(() => import('../Page/Billing/SearchBillEvidence')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'billing/searchbillingmessage',
        component: asyncComponent(() => import('../Page/Billing/SearchBillingMessage')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'billing/preference',
        component: asyncComponent(() => import('../Page/Billing/Preference')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'phonebook',
        component: asyncComponent(() => import('../Page/Phonebook')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PHONEBOOK').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PHONEBOOK').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'facilitybooking',
        component: asyncComponent(() => import('../Page/FacilityBooking')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'facilitybooking/booking',
        component: asyncComponent(() => import('../Page/FacilityBooking/Booking')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false :  communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false :  communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'facilitybooking/mybooking',
        component: asyncComponent(() => import('../Page/FacilityBooking/MyBooking')),
        // isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'facilitybooking/management',
        component: asyncComponent(() => import('../Page/FacilityBooking/ManageFacility')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'facilitybooking/preference',
        component: asyncComponent(() => import('../Page/FacilityBooking/Preference')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'facilitybooking/add',
        component: asyncComponent(() => import('../Page/FacilityBooking/ManageFacility/addFacility')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'facilitybooking/management/detail',
        component: asyncComponent(() => import('../Page/FacilityBooking/ManageFacility/facilityDetail')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'facilitybooking/management/detail/edit',
        component: asyncComponent(() => import('../Page/FacilityBooking/ManageFacility/editFacility')),
        // isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'suggestion',
        component: asyncComponent(() => import('../Page/Suggestion')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='SUGGESTION').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='SUGGESTION').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'suggestion/preference',
        component: asyncComponent(() => import('../Page/Suggestion/Preference')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='SUGGESTION').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='SUGGESTION').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'repair',
        component: asyncComponent(() => import('../Page/Repair')),
        //isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,
        //isEnable: communityType ==="VILLAGE" ? false : true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'repair/detail',
        component: asyncComponent(() => import('../Page/Repair/RepairDetail')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,      },
      {
        path: 'repair/appointment',
        component: asyncComponent(() => import('../Page/Repair/RepairAppointmentList')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,      },
      {
        path: 'repair/preference',
        component: asyncComponent(() => import('../Page/Repair/Preference')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,      },
      {
        path: 'repair/createnew',
        component: asyncComponent(() => import('../Page/Repair/RepairForm')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,      },
      {
        path: 'repair/search',
        component: asyncComponent(() => import('../Page/Repair/Search')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,      },
      {
        path: 'repair/history',
        component: asyncComponent(() => import('../Page/Repair/RepairHistoryList')),
        //isEnable: true,
        isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,      },
      {
        path: 'chat',
        component: asyncComponent(() => import('../Page/Chat')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='CHAT_NITI').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='CHAT_NITI').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'chat/preference',
        component: asyncComponent(() => import('../Page/Chat/Preference')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='CHAT_NITI').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='CHAT_NITI').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'regulation',
        component: asyncComponent(() => import('../Page/Regulation')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='COMMUNITY_RULES').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='COMMUNITY_RULES').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'recycling',
        component: asyncComponent(() => import('../Page/Recycling')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='RECYCLING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='RECYCLING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'losservices',
        component: asyncComponent(() => import('../Page/LOSServices')),
        isEnable: true,
        isVisible: true
        // isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='LOS_SERVICES').map(ele=>ele.isEnable)[0] : false,
        // isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='LOS_SERVICES').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'vms',
        component: asyncComponent(() => import('../Page/VMS')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='VMS_NITI').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='VMS_NITI').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'patrol',
        component: asyncComponent(() => import('../Page/Patrol')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PATROL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PATROL').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'agmmeeting',
        component: asyncComponent(() => import('../Page/AGMMeeting')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='AGM_MEETING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='AGM_MEETING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'incident',
        component: asyncComponent(() => import('../Page/IncidentReport')),
        isEnable: true,
        isVisible: true
        // isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='COMMUNITY_RULES').map(ele=>ele.isEnable)[0] : false,
        // isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='COMMUNITY_RULES').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'tutorial',
        component: asyncComponent(() => import('../Page/Tutorial')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='TUTORIAL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='TUTORIAL').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'tutorial/vdo',
        component: asyncComponent(() => import('../Page/Tutorial')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='TUTORIAL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='TUTORIAL').map(ele=>ele.isEnable)[0] : false,      },
      {
        path: 'tutorial/res',
        component: asyncComponent(() => import('../Page/Tutorial/s3')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='TUTORIAL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='TUTORIAL').map(ele=>ele.isEnable)[0] : false,      },
      {
        path: 'tutorial/pr',
        component: asyncComponent(() => import('../Page/Tutorial/resPR')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='TUTORIAL').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='TUTORIAL').map(ele=>ele.isEnable)[0] : false,      },
      {
        path: 'settings',
        component: asyncComponent(() => import('../Page/Settings')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='SETTING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='SETTING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'settings/community/edit',
        component: asyncComponent(() => import('../Page/Settings/Community/CommunityInfo/CommunityForm')),
        //isEnable: true,
        isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='SETTING').map(ele=>ele.isEnable)[0] : false,
        isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='SETTING').map(ele=>ele.isEnable)[0] : false,
      },
      {
        path: 'blankPage',
        component: asyncComponent(() => import('../blankPage')),
        isEnable: true,
        isVisible: true,
      },
      {
        path: 'authCheck',
        component: asyncComponent(() => import('../AuthCheck')),
        isEnable: true,
        isVisible: true,
      },
      {
        path: '*',
        //component: asyncComponent(() => import('../Page/404')),
        component: asyncComponent(() => import('../Page/featureDiabledPage')),
        isEnable: true,
        isVisible: true,
      },
    ];

    return (
      <div style={style}>
       <Switch>
        {routes.map(singleRoute => {
          const { path, isEnable, exact, ...otherProps } = singleRoute;
          if(singleRoute.isEnable){
            return (
                  <Route
                    exact={exact === false ? false : true}
                    key={singleRoute.path}
                    path={`${url}/${singleRoute.path}`}
                    {...otherProps}
                  />
            );
          }
        })}
        </Switch>
      </div>
    );
  }
}

export default AppRouter;
